import { render, staticRenderFns } from "./top-link-referrals-card.vue?vue&type=template&id=54662d2a&scoped=true&"
import script from "./top-link-referrals-card.vue?vue&type=script&lang=js&"
export * from "./top-link-referrals-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54662d2a",
  null
  
)

export default component.exports